/*----- Size Guide Button -------*/
document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('size-guide-modal');
    const openBtn = document.getElementById('open-size-guide');
    const closeBtn = document.getElementById('size-guide-close');
    const overlay = document.querySelector('.size-guide-overlay');

    if (openBtn) {
        openBtn.addEventListener('click', () => {
            modal.style.display = 'block';
            document.body.style.overflow = 'hidden';
        });
    }

    const closeModal = () => {
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';
    };

    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);
});
/*----Dispatch Timer----*/
function updateTimer() {
const now = new Date();
const deadline = new Date();
deadline.setHours(16, 0, 0, 0);

const diff = deadline - now;
const timerContainer = document.getElementById('dispatch-timer-container');

if (diff <= 0) {
    if (timerContainer) timerContainer.innerHTML = '<div class="dispatch-subtext">Ships next working day</div>';
    return;
}

const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
const minutes = Math.floor((diff / (1000 * 60)) % 60);
const seconds = Math.floor((diff / 1000) % 60);

const timerDisplay = document.getElementById('dispatch-timer');
if (timerDisplay) {
    timerDisplay.innerText = 
    `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}
}

// Only run if the elements exist
if (document.getElementById('dispatch-timer') || document.getElementById('dispatch-timer-container')) {
setInterval(updateTimer, 1000);
updateTimer();
}

/*----- Mini Video Player -------*/
(function() {
    // Elements
    const player = document.getElementById('mini-video-player');
    if(!player) return;
    const video = document.getElementById('mini-video');
    const btnClose = player.querySelector('.mvp-close');
    const btnExpand = player.querySelector('.mvp-expand');
    const addToCartBtn = document.getElementById('mvp-addtocart');
    const variantId = player.dataset.variantId || '';

    // Show after full page load so it doesn't block or delay page rendering
    window.addEventListener('load', function() {
        player.style.display = 'block';
        // autoplay muted (required in most mobile browsers)
        const playPromise = video.play();
        if (playPromise !== undefined) {
            playPromise.catch(() => {
                // autoplay might be blocked; we keep it muted and will attempt on user interaction
            });
        }
    });

    // --- Expand (fake fullscreen) ---
    function enterExpandedMode() {
        // disable dragging while expanded
        disableDragging();

        // add expanded class
        player.classList.add('mvp-expanded');
        player.setAttribute('aria-hidden', 'false');

        // allow sound after a user-triggered action
        try {
            video.muted = false;
        } catch (e) {}

        // play (ensures it continues)
        video.play().catch(() => {
            /* ignored */
        });

        // prevent page scroll while expanded
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
    }

    function exitExpandedMode() {
        player.classList.remove('mvp-expanded');
        player.setAttribute('aria-hidden', 'true');

        // re-mute to avoid unexpected sound when returning to mini
        try {
            video.muted = true;
        } catch (e) {}

        // re-enable dragging
        enableDragging();

        // reallow page scroll
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
    }

    btnExpand.addEventListener('click', function(e) {
        // If already expanded -> act as "back" (close expanded)
        if (player.classList.contains('mvp-expanded')) {
            exitExpandedMode();
            return;
        }

        // This is a user gesture; safe to unmute & expand
        enterExpandedMode();
    });

    // Close mini completely
    btnClose.addEventListener('click', function() {
        // if expanded, exit expanded first, then hide
        if (player.classList.contains('mvp-expanded')) {
            exitExpandedMode();
        }
        // hide and pause
        player.style.display = 'none';
        try {
            video.pause();
        } catch (e) {}
    });

    // Add to cart (AJAX POST)
    addToCartBtn.addEventListener('click', function() {
        if (!variantId) {
            alert('Variant unavailable');
            return;
        }
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Adding…';

        fetch('/cart/add', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams({
                    id: variantId,
                    quantity: 1
                }).toString(),
            })
            .then((res) => {
                if (!res.ok) throw new Error('Add to cart failed');
                // Optionally show a quick confirmation or open cart drawer
                addToCartBtn.textContent = 'Added ✓';
                setTimeout(() => (addToCartBtn.textContent = 'Add to cart'), 1500);
            })
            .catch((err) => {
                console.error(err);
                addToCartBtn.textContent = 'Error';
                setTimeout(() => (addToCartBtn.textContent = 'Add to cart'), 1500);
            })
            .finally(() => {
                addToCartBtn.disabled = false;
            });
    });

    // --- Dragging (desktop + touch) ---
    let dragging = false,
        dragOffsetX = 0,
        dragOffsetY = 0;

    function enableDragging() {
        // Desktop mouse
        player.addEventListener('mousedown', onPointerDown);
        document.addEventListener('mouseup', onPointerUp);
        document.addEventListener('mousemove', onPointerMove);

        // Touch
        player.addEventListener('touchstart', onTouchStart, {
            passive: false
        });
        document.addEventListener('touchend', onTouchEnd);
        document.addEventListener('touchmove', onTouchMove, {
            passive: false
        });
    }

    function disableDragging() {
        player.removeEventListener('mousedown', onPointerDown);
        document.removeEventListener('mouseup', onPointerUp);
        document.removeEventListener('mousemove', onPointerMove);

        player.removeEventListener('touchstart', onTouchStart);
        document.removeEventListener('touchend', onTouchEnd);
        document.removeEventListener('touchmove', onTouchMove);
    }

    function onPointerDown(e) {
        // avoid dragging if user clicked a control
        if (e.target.closest('.mvp-btn')) return;
        dragging = true;
        dragOffsetX = e.clientX - player.offsetLeft;
        dragOffsetY = e.clientY - player.offsetTop;
        player.style.cursor = 'grabbing';
        e.preventDefault();
    }

    function onPointerMove(e) {
        if (!dragging) return;
        const x = e.clientX - dragOffsetX;
        const y = e.clientY - dragOffsetY;
        // keep inside viewport
        setPlayerPosition(
            Math.min(Math.max(0, x), window.innerWidth - player.offsetWidth),
            Math.min(Math.max(0, y), window.innerHeight - player.offsetHeight)
        );
    }

    function onPointerUp() {
        dragging = false;
        player.style.cursor = 'grab';
    }

    // touch events
    function onTouchStart(e) {
        if (e.target.closest('.mvp-btn')) return;
        const t = e.touches[0];
        dragging = true;
        dragOffsetX = t.clientX - player.offsetLeft;
        dragOffsetY = t.clientY - player.offsetTop;
        e.preventDefault();
    }

    function onTouchMove(e) {
        if (!dragging) return;
        const t = e.touches[0];
        const x = t.clientX - dragOffsetX;
        const y = t.clientY - dragOffsetY;
        setPlayerPosition(
            Math.min(Math.max(0, x), window.innerWidth - player.offsetWidth),
            Math.min(Math.max(0, y), window.innerHeight - player.offsetHeight)
        );
        e.preventDefault();
    }

    function onTouchEnd() {
        dragging = false;
    }

    function setPlayerPosition(x, y) {
        player.style.left = x + 'px';
        player.style.top = y + 'px';
        // ensure fixed coordinates are used
        player.style.right = 'auto';
        player.style.bottom = 'auto';
    }

    // Initialize dragging
    enableDragging();

    // If user resizes while expanded, ensure video stays centered (CSS handles most)
    window.addEventListener('resize', function() {
        if (player.classList.contains('mvp-expanded')) {
            // do nothing (CSS handles layout)
        } else {
            // keep player within bounds
            const curLeft = player.offsetLeft;
            const curTop = player.offsetTop;
            const maxLeft = Math.max(0, window.innerWidth - player.offsetWidth);
            const maxTop = Math.max(0, window.innerHeight - player.offsetHeight);
            if (curLeft > maxLeft || curTop > maxTop) {
                setPlayerPosition(Math.min(curLeft, maxLeft), Math.min(curTop, maxTop));
            }
        }
    });

    // Accessibility: allow ESC to close expanded
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && player.classList.contains('mvp-expanded')) {
            exitExpandedMode();
        }
    });
})();

